import React from 'react';

import useToggle from '@lyearn/core/hooks/useToggle';
import { ErrorBoundary, PageError } from '@/components/Error';

import ExerciseEditorModal from './components/ExerciseEditorModal';
import ExerciseCard from './ExerciseCard';
import { ExerciseCardContainerProps } from './types';

function ExerciseCardContainer({
  updateAttribute,
  exerciseId,
  editable,
  duration,
  id,
  inlinePlayer,
}: ExerciseCardContainerProps) {
  const [showEditorModal, { on: openEditorModal, off: closeEditorModal }] = useToggle(false);

  return (
    <ErrorBoundary fallback={PageError}>
      <ExerciseCard
        duration={duration}
        editable={editable}
        exerciseId={exerciseId}
        id={id}
        inlinePlayer={inlinePlayer}
        updateAttribute={updateAttribute}
        onCreateNew={openEditorModal}
        onEditExercise={editable ? openEditorModal : undefined}
      />
      {editable ? (
        <ExerciseEditorModal
          exerciseId={exerciseId || undefined}
          open={showEditorModal}
          updateAttribute={updateAttribute}
          onClose={closeEditorModal}
        />
      ) : null}
    </ErrorBoundary>
  );
}

export default ExerciseCardContainer;
